import { Expand, Filter, OrderBy, Select } from 'odata-query';
import { CommandResult, FormApiService, ODataResult, QueryApiService } from 'src/common/api-service';
import { AddEnterpriseReview, AddPersonReview, J2LContract } from './types';
import { AxiosError } from 'axios';

export class J2LContractApiService extends QueryApiService<J2LContract> {
  constructor() {
    super('j2lContract');
  }

  public async getContract(options: {
    select?: Select<J2LContract>;
    expand?: Expand<J2LContract>;
    orderBy?: OrderBy<J2LContract>;
    filter?: Filter<J2LContract>;
    count?: boolean;
    top?: number;
    skip?: number;
  }): Promise<ODataResult<J2LContract>> {
    const q = await this.getWithOData(options);

    return q;
  }
}

export class J2LContractFromApiService extends FormApiService {
  constructor() {
    super('j2lContract');
  }

  public async acceptOffer(id: string) {
    try {
      return await this.put<Record<string, never>, CommandResult>({}, `${id}/Person/Accept`);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async addPersonReview(id: string, body: AddPersonReview) {
    try {
      return await this.put<AddPersonReview, CommandResult>(body, `${id}/person-review`);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async addEnterpriseReview(id: string, body: AddEnterpriseReview) {
    try {
      return await this.put<AddEnterpriseReview, CommandResult>(body, `${id}/enterprise-review`);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
